import $ from 'jquery';
import { debounce } from 'lodash';

import TargetingClient from '~/state/Targeting/client';
import AgentsClient from '~/state/Agents/client';
import CampaignClient from '~/state/Campaign/client';

import { render, querySubscription } from '~/theseus';
import AgentLanding from '~/theseus/components/AgentLanding';
import Navbar from '~/theseus/components/Navbar';
import AdPreview from '~/theseus/components/AdPreview';

import analyzeLink from './shared/analyze';
import { renderCreative } from './shared/creatives';
import { lb } from './shared/lightbox';
import { init } from './shared/login';

import {
  publishControls,
  params,
  get_server_url,
  add_tag,
  post_ad,
  checkLinkType,
} from './components/common';
import { displayOffice, checkDisplayLO } from './components/search-display-office';
import { generatePreview, validateAtLeastTwoImages } from './components/ad-preview';
import getCreatives from './components/getCreatives';
import {
  isSmall,
  getSmallImages,
  addSmallWarning,
  resetSmallWarning,
  isInstagramAd,
} from './lib/instagram';

const LINK_TYPE = 'area';

let link = null;
let repost = null;
let search_keys = null;
let property_keys = null;
let office_id = null;
let $sub = null;
let source_domain = null;
let source_short_link = null;
let past_templates = 'none';
const max_props = 5;
let properties = [];
let $creative_doms = [];
let past_main_creatives = [];
let past_sub_creatives = [];
let field_divs = {};
let criteria = {};
let set_imgs_type = 'map';
let lines = [];
const override_lookup = {
  alert_status: {
    ACTIVE: 'Active',
    __GRAY__: 'Under Contract',
    SOLD: 'Sold',
  },
};
let lookup = {};
let use_office_id = false;
let $active;
let rendered_main_creative;
let ranAnalyze = false;
let format_option = 'area_page';
const sub_creative_markup = `
  <div class='creative-item creative-item--search-preview' style='display: -webkit-box; display: -webkit-flex; display: -ms-flexbox; display: flex;'>
    <div class='creative-item__thumbnail'>
      <img />
    </div>
    <form action='' class='creative-item__edit-creatives'>
      <div class='creative-item__row'>
        <p class='creative-item__first-preview'></p>
      </div>
      <div class='creative-item__row'>
        <p class='creative-item__second-preview'></p>
      </div>
      <div class='creative-item__actions'>
        <button type=button class=creative-item__option></button>
      </div>
    </form>
  </div>
`;

let account_id = null;
let page_id = null;

querySubscription('account_id', (id) => { account_id = id; });
querySubscription('page_id', (id) => { page_id = id; });

wire_keyup($('.main-creative__field'), $('.main-creative__preview'), -1, -1);

if ('creative' in params) {
  $('.main-creative__field').val(params.creative);
  $('.main-creative__field').focus();
  $('.main-creative__field').trigger('keyup');
}

$('.main-creative__field').on('focus', () => {
  if (past_templates === 'main') {
    return;
  }
  add_fields(search_keys, criteria);
  past_templates = 'main';
  $('.past-templates__container').hide();
  $('.past-templates__container').empty();
  past_main_creatives.forEach((v) => {
    const $item = $(`<div class='past-templates__item'>${v.markedup}</div>`);
    $('.past-templates__container').append($item);
    $('.past-templates__container').slideDown('fast');
    $item.on('click', () => {
      $('.main-creative__field').val(v.template);
      $('.main-creative__field').focus();
      $('.main-creative__field').trigger('keyup');
    });
  });
});

function set_sub_imgs(v) {
  if (v === 'mls') {
    $('#check-mls-img').attr('checked', 'checked');
  } else if (v === 'map') {
    $('#check-map-img').attr('checked', 'checked');
  }
  set_imgs_type = v;
}

set_sub_imgs(set_imgs_type);

$('#check-map-img').on('change', () => {
  if ($('#check-map-img').is(':checked')) {
    set_sub_imgs('map');
  } else {
    set_sub_imgs('mls');
  }
});

$('#check-mls-img').on('change', () => {
  if ($('#check-map-img').is(':checked')) {
    set_sub_imgs('map');
  } else {
    set_sub_imgs('mls');
  }
});

function wire_keyup($i, $p) {
  const input = $i.get(0);
  let p = null;

  $i.on('keyup', debounce(() => {
    const v = $i.val();
    criteria.list_price = '';

    renderCreative({
      creative_text: v, key_values: criteria, lookup, override_lookup,
    })
      .then((res) => {
        rendered_main_creative = res.subbed;
        $p.html(res.markedup);
      })
      .catch(err => console.error('area - render error: ', err));
  }, 20));

  $p.on('mouseenter', 'span', (e) => {
    p = input.selectionStart;
    $i.addClass('field--preview');
    if ($(e.target).hasClass('not-found')) $i.addClass('field--preview-not-found');
    input.focus();
    input.setSelectionRange($(e.target).attr('data-start'), $(e.target).attr('data-stop'));
    if ($(e.target).attr('data-field') in field_divs) {
      field_divs[$(e.target).attr('data-field')].addClass('available-fields__item--preview');
    }
  });

  $p.on('mouseleave', 'span', (e) => {
    $i.removeClass('field--preview field--preview-not-found');
    if ($(e.target).attr('data-field') in field_divs) {
      field_divs[$(e.target).attr('data-field')].removeClass('available-fields__item--preview');
    }
    if (p != null) {
      input.setSelectionRange(p, p);
    }
  });

  $p.on('click', 'span', (e) => {
    const v = $i.val();
    const start = parseInt($(e.target).attr('data-start'), 10);
    const stop = parseInt($(e.target).attr('data-stop'), 10);
    let replacement = $(e.target).html();
    const new_p = start + replacement.length;

    if ($(e.target).hasClass('not-found')) replacement = '';
    $i.removeClass('field--preview field--preview-not-found');
    if ($(e.target).attr('data-field') in field_divs) {
      field_divs[$(e.target).attr('data-field')].removeClass('available-fields__item--preview');
    }
    $i.val(v.substring(0, start) + replacement + v.substring(stop));
    $i.focus();
    $i.trigger('keyup');
    input.setSelectionRange(new_p, new_p);
  });
}

function wire_keyup_sub($i, selector, j) {
  $i.off().on('keyup', debounce(() => {
    const v = $i.val();
    lines[j] = v;
    properties.forEach((property, i) => {
      renderCreative({
        creative_text: v,
        key_values: property,
        lookup,
        override_lookup,
      })
        .then((res) => {
          property.creative_lines[j] = res.subbed;
          checkDisplayLO(property);
          $creative_doms[i].find(selector).html(property.creative_lines[j]);
        })
        .catch((err) => {
          $creative_doms[i].find(selector).html('error');
          console.error('area - error rendering creatives: ', err);
        });
    });
  }, 20));
}

$sub = $('.creative-item__edit-creatives');

$sub.find('input.can-add-tags').on('focus', () => {
  if (past_templates === 'sub') { return; }
  past_templates = 'sub';
  add_fields(property_keys, properties[0]);
  $('.past-templates__container').hide();
  $('.past-templates__container').empty();
  past_sub_creatives.forEach((v) => {
    const markedup = v.markedup.split('///');
    const template = v.template.split('///');
    const $item = $(`<div class='past-templates__item'><div class='past-templates__row'>${markedup[0]}</div><div class='past-templates__row'>${markedup[1]}</div></div>`);
    $('.past-templates__container').append($item);
    $('.past-templates__container').slideDown('fast');
    $item.on('click', () => {
      lines[0] = v.x;
      lines[1] = v.y;
      $sub.find('.creative-item__first-sub').val(template[0]);
      $sub.find('.creative-item__second-sub').val(template[1]);
      $sub.find('.creative-item__first-sub').focus();
      $sub.find('.creative-item__first-sub').trigger('keyup');
      $sub.find('.creative-item__second-sub').trigger('keyup');
    });
  });
});

$('.link__container').on('submit', () => {
  $('.link__add-link').addClass('link__add-link--loading');
  $('.link__input').addClass('link__input--loading');
  link = $.trim($('.link__input').val());
  if (ranAnalyze) {
    alert('The page will refresh to load the new area');
    window.onbeforeunload = null;
    window.location.search = `?link=${encodeURIComponent(link)}`;
  }

  const analyzeParams = {
    link,
    n_max: 10,
  };

  if (use_office_id) analyzeParams.office_id = office_id;

  analyzeLink('analyze_link', LINK_TYPE, analyzeParams, repost?.lead_ad_enabled)
    .then((res) => {
      checkLinkType(link, 'search', res.analyze_type);
      ranAnalyze = true;
      source_domain = res.domain;
      source_short_link = res.link;
      past_templates = 'none';
      past_main_creatives = [];
      past_sub_creatives = [];
      field_divs = {};

      /* eslint-disable */
      lookup = res.lookup;
      criteria = res.criteria;
      search_keys = res.search_keys;
      property_keys = res.property_keys;
      properties = res.properties;
      /* eslint-enable */

      TargetingClient.setAsReady();

      $('.main-creative').removeClass('main-creative--disabled');
      $('.image-picker').removeClass('image-picker--disabled');
      $('.button-group').removeClass('button-group--disabled');
      $('.campaign').removeClass('campaign--hidden');
      $('.creative-item__image-type').off('change');
      $('.image-picker__creatives-container').empty();
      properties.forEach((prop, i) => {
        prop.creative_lines = [];
        if (i < max_props) { prop.selected = true; }
      });
      set_order();
      run_display_properties();
      displayOffice($('.creative-item--search .creative-item__edit-creatives'));
      wire_keyup_sub($sub.find('.creative-item__first-sub'), '.creative-item__first-preview', 0);
      wire_keyup_sub($sub.find('.creative-item__second-sub'), '.creative-item__second-preview', 1);
      $active = $('.main-creative__field');
      $('.main-creative__descr').html(res.description);
      CampaignClient.ad.changeName(res.name);
      if (repost) {
        $('.main-creative__field').val(repost.main_creative).keyup();
        const sub = repost.sub_creative.split('///');
        $('.creative-item__first-sub').val(sub[0]).keyup();
        $('.creative-item__second-sub').val(sub[1]).keyup();
      }

      return Promise.all([
        getCreatives({
          type: 'area',
          keys: search_keys,
          key_values: criteria,
          lookup,
          override_lookup,
        }),
        getCreatives({
          type: 'area_sub',
          keys: search_keys,
          key_values: criteria,
          lookup,
          override_lookup,
        }),
      ]);
    })
    .then(([main_creatives, sub_creatives]) => {
      // main creatives stuff
      past_main_creatives = main_creatives;
      past_templates = 'none';

      $('.main-creative__field').focus();
      $('.main-creative__field').trigger('keyup');
      $('.creative-item__first-sub').trigger('keyup');
      $('.creative-item__second-sub').trigger('keyup');

      // sub creatives stuff
      past_sub_creatives = sub_creatives;
    })
    .catch((err) => {
      console.error('area - analyzeLink error: ', err);
      alert('Error loading area/content/search link');
      $('.link__add-link').removeClass('link__add-link--loading');
      $('.link__input').removeClass('link__input--loading');
    });
  return false;
});

function set_order() {
  const sel = selected_properties();
  sel.sort((a, b) => a.order - b.order);
  sel.forEach((prop, i) => {
    prop.order = i + 1;
  });
}

function selected_properties() {
  return properties.filter(prop => prop.selected);
}

function run_display_properties() {
  $('.image-picker__selected-searches').empty();
  $('.image-picker__creatives-container').empty();
  display_properties();
  $('.creative-item__image-type').trigger('change');
  $sub.find('.creative-item__first-sub').trigger('keyup');
  $sub.find('.creative-item__second-sub').trigger('keyup');
}

function display_properties() {
  $creative_doms = [];
  const $disclaimer_dom = $(`
    <div class=image-picker__selected-disclaimer>
      <p>We send up to 5 properties to Facebook. Select or Remove the properties you want to send.</p>
      <button type=button class=image-picker__clear-selected>Clear All</button>
    </div >
  `);
  $('.image-picker__selected-searches').append($disclaimer_dom);
  set_order();
  properties.sort((a, b) => a.order - b.order).forEach((property, i) => {
    create_image_creative(property, i);
  });
  $disclaimer_dom.find('.image-picker__clear-selected').on('click', () => {
    properties.forEach((property) => { property.selected = false; });
    run_display_properties();
  });
}

function create_image_creative(prop, i) {
  const $dom = $(sub_creative_markup);
  const selected_size = selected_properties().length;
  const $button = $dom.find('.creative-item__option');
  const $img = $dom.find('img');

  $img[0].onload = (e) => {
    resetSmallWarning($img);
    if (isSmall(e.target)) {
      addSmallWarning($img);
    }
  };

  $creative_doms.push($dom);
  $dom.find('.creative-item__first-preview').html(prop.creative_lines[0]);
  $dom.find('.creative-item__second-preview').html(prop.creative_lines[1]);
  if (prop.selected) {
    $('.image-picker__selected-searches').append($dom);
    $button.html('Remove');
  } else {
    prop.order = null;
    $('.image-picker__creatives-container').append($dom);
    if (!prop.selected && selected_size === max_props) {
      $button.addClass('creative-item__option--disabled')
        .html('Remove Properties Before Adding More');
    } else { $button.html('Select'); }
  }
  $('.creative-item__image-type').on('change', () => {
    if (set_imgs_type === 'mls') {
      $img.attr('src', properties[i].images[0]);
    } else {
      $img.attr('src', properties[i].map_url);
    }
  });
  $dom.find('.creative-item__thumbnail').attr('data-creative-order', prop.order);
  $dom.find('.creative-item__option').on('click', () => {
    if (!prop.selected && selected_size === max_props) {
      return false;
    } if (!prop.selected) {
      $dom.slideUp(200, () => {
        prop.selected = true;
        prop.order = 999;
        $('.image-picker__selected-searches')
          .addClass('image-picker__selected-searches--adding');
        run_display_properties();
      });
    } else if (prop.selected) {
      $dom.slideUp(200, () => {
        prop.selected = false;
        $('.image-picker__selected-searches')
          .removeClass('image-picker__selected-searches--adding');
        run_display_properties();
      });
    }
  });
}

function add_fields(fields, key_values) {
  $('.available-fields__container').empty();
  fields.forEach((key) => {
    const $item = $("<li class='available-fields__item'></li>").html(key);
    field_divs[key] = $item;
    $('.available-fields__container').append($item);
    $item.on('mouseenter', () => {
      $('.available-fields__display-value').html(key_values[key]);
    });
    $item.on('click', () => {
      add_tag(key, null, $active);
    });
  });
}

function post_specific_ad() {
  const send_properties = [];
  selected_properties().forEach((prop) => {
    const send = {
      img: set_imgs_type === 'map' ? prop.map_url : prop.images[0],
      property_url: prop.url,
      sub_creative: `${prop.creative_lines[0]}///${prop.creative_lines[1]}`,
      order: prop.order,
    };
    send_properties.push(send);
  });
  const more_data = {
    format_option,
    domain: source_domain,
    link,
    original_link: link,
    short_link: source_short_link,
    sub_creative: `${lines[0]}///${lines[1]}`,
    img_type: set_imgs_type,
    properties: JSON.stringify(send_properties),
    main_creative: $('.main-creative__field').val(),
    rendered_main_creative,
    office_id: use_office_id ? office_id : null,
  };
  if (send_properties.length < 2) {
    alert('You must select at least two properties before creating a post or ad.');
    return false;
  }

  const smallImages = getSmallImages('fixed').blocking;
  if (smallImages.length !== 0 && isInstagramAd()) {
    lb('Some of your images are too small to post on Instagram. Please try a single or multi-link ad with your own images (at least 500px by 500px), or don\'t run this ad on Instagram.', 'fail', null, null, false, false);
    return false;
  }

  post_ad('fixed', 'area', more_data, null, account_id, page_id);
  return false;
}

function set_property_format(v) {
  if (v === 'area_landing') {
    $('#landing-check').attr('checked', 'checked');
  } else if (v === 'area_page') {
    $('#content-check').attr('checked', 'checked');
  } else if (v === 'area_results') {
    $('#results-check').attr('checked', 'checked');
  }
  format_option = v;
}

set_property_format(format_option);

$('#content-check').on('change', () => {
  set_property_format('area_page');
});

$('#landing-check').on('change', () => {
  set_property_format('area_landing');
});

$('#results-check').on('change', () => {
  set_property_format('area_results');
});

$('.creative-item__clear-creative').on('click', () => {
  lines = [];
  $('.creative-item__first-sub').val('').keyup();
  $('.creative-item__second-sub').val('').keyup();
});

$('.creative-item__set-default').on('click', (e) => {
  lines[0] = $('.creative-item__first-sub').val();
  lines[1] = $('.creative-item__second-sub').val();
  $(e.target).removeClass('creative-item__set-default--success');
  $(e.target).removeClass('creative-item__set-default--failed');
  $(e.target).addClass('creative-item__set-default--loading');


  const formData = new FormData();
  formData.append('key', 'default_content_subs');
  formData.append('value', `${lines[0]}///${lines[1]}`);

  fetch(get_server_url('set_domain_setting'), {
    mode: 'cors',
    credentials: 'include',
    body: formData,
    method: 'POST',
  })
    .then(res => (res.ok ? res.json() : Promise.reject(res)))
    .then(() => {
      $(e.target).removeClass('creative-item__set-default--loading');
      $(e.target).addClass('creative-item__set-default--success');
    })
    .catch(() => {
      alert('Could not save default...');
      $(e.target).removeClass('creative-item__set-default--loading');
      $(e.target).addClass('creative-item__set-default--failed');
    });
});

function get_default_sub() {
  const formData = new FormData();
  formData.append('key', 'default_content_subs');

  fetch(get_server_url('get_domain_setting'), {
    mode: 'cors',
    credentials: 'include',
    body: formData,
    method: 'POST',
  })
    .then(res => (res.ok ? res.json() : Promise.reject(res)))
    .then((res) => {
      if (res == null || res == '///' || res == '') {
        lines = [
          '[beds|Bed], [baths|Bath], [living_area] sq. ft.',
          '[list_price], [city]',
        ];
        $('.creative-item__first-sub').val(lines[0]);
        $('.creative-item__second-sub').val(lines[1]);
      } else {
        /* eslint-disable */
        lines[0] = r.split('///')[0];
        lines[1] = r.split('///')[1];
        /* eslint-enable */
        $('.creative-item__first-sub').val(lines[0]);
        $('.creative-item__second-sub').val(lines[1]);
      }
    })
    .catch(() => {
      console.error('Could not get default...');
    });
}

function set_use_office_id(v) {
  if (v) {
    const formData = new FormData();
    formData.append('key', 'office_id');

    fetch(get_server_url('get_domain_setting'), {
      mode: 'cors',
      credentials: 'include',
      body: formData,
      method: 'POST',
    })
      .then((res) => {
        if (res == null) {
          alert('You do not have any office IDs saved.\nGo to Settings under "Navigation" to save your office ID.');
          $('#check-office-id').attr('checked', false);
          use_office_id = false;
        } else {
          office_id = res;
          $('#check-office-id').attr('checked', true);
          use_office_id = true;
          $('.link__container').trigger('submit');
        }
      })
      .catch(() => {
        alert('Could Not Get Office ID');
        $('#check-office-id').attr('checked', false);
        use_office_id = false;
      });
  } else {
    $('#check-office-id').attr('checked', false);
    const previous_use_office_id = use_office_id;
    use_office_id = false;
    if (previous_use_office_id) {
      $('.link__container').trigger('submit');
    }
  }
}

set_use_office_id(use_office_id);

$('#check-office-id').on('change', () => {
  if ($('#check-office-id:checked').val()) {
    set_use_office_id(true);
  } else {
    set_use_office_id(false);
  }
});

function on_repost(post) {
  repost = post;
  $('.link__input').val(repost.link);
  $('.link__container').trigger('submit');
}

$('body').on('focus', '.can-add-tags', (e) => {
  $active = $(e.target);
});

function generateSubs() {
  const psubs = {
    creatives: [],
    ad_campaign_cta: $('#campaign-cta').val(),
  };

  selected_properties().forEach((prop, i) => {
    psubs.creatives.push({
      i,
      template: `${prop.creative_lines[0]}///${prop.creative_lines[1]}`,
      img: set_imgs_type === 'map' ? prop.map_url : prop.images[0],
    });
  });

  return psubs;
}


function createPreview(previewType) {
  const psubs = generateSubs();
  return generatePreview(
    page_id,
    account_id,
    link,
    rendered_main_creative,
    psubs,
    override_lookup,
    $('#check-end-card').prop('checked'),
    previewType,
  );
}

function load_data() {
  render('#agent-landing', <AgentLanding />);
  get_default_sub();
  publishControls('#publish_container', post_specific_ad, LINK_TYPE);
  render('#ad-preview', <AdPreview getPreview={createPreview} validation={validateAtLeastTwoImages(() => generateSubs())} />);
}

init(on_repost)
  .then(load_data);
